import { render, staticRenderFns } from "./item-recommended.vue?vue&type=template&id=10efce4c&scoped=true"
import script from "./item-recommended.vue?vue&type=script&lang=js"
export * from "./item-recommended.vue?vue&type=script&lang=js"
import style0 from "./item-recommended.vue?vue&type=style&index=0&id=10efce4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10efce4c",
  null
  
)

export default component.exports